export const fields = [
  "companyName",
  "prefectureName",
  "cityName",
  "townName",
  "corporateNumber",
  "corporateIdentificationNumber",
] as const;
export type Field = (typeof fields)[number];
export type Mapping = Partial<Record<Field, number | null>>;
export const labels: Record<Field, string> = {
  companyName: "法人名",
  prefectureName: "都道府県",
  cityName: "市区町村",
  townName: "町名（任意）",
  corporateNumber: "法人番号（13桁）",
  corporateIdentificationNumber: "会社法人等番号（12桁）",
};
export interface ParsedFile {
  columns: Array<{ index: number; header: string }>;
  rows: Array<{
    rowNumber: number;
    cells: Array<{ value: string; errorCode: string | null }>;
  }>;
  fileType: string;
  encoding: string | null;
}
export interface FileErrorResponse {
  code: string;
  message: string;
  rowNumber: number | null;
  physicalLine: number | null;
}
export interface InputRow extends Record<Field, string> {
  rowNumber: number;
  resolutionSource: "AUTO" | "CANDIDATE" | "MANUAL";
  explicitlyExcluded: boolean;
  cellErrors: Partial<Record<Field, string>>;
}
export interface Corporation {
  corporateNumber: string;
  corporateIdentificationNumber: string;
  companyName: string;
  prefectureName: string;
  cityName: string;
  streetNumber: string;
}
export interface MatchedRow {
  rowNumber: number;
  status:
    | "NUMBER_MATCHED"
    | "AUTO_ASSIGNED"
    | "NEEDS_REVIEW"
    | "UNMATCHED"
    | "ERROR"
    | "DUPLICATE";
  targetState: "TARGET" | "HELD" | "EXCLUDED";
  resolutionSource: InputRow["resolutionSource"];
  explicitlyExcluded: boolean;
  corporation: Corporation | null;
  candidates: Corporation[];
  candidateCount: number;
  candidatesTruncated: boolean;
  confidence: string | null;
  reasonCodes: string[];
  warningCodes: string[];
  duplicateOfRowNumber: number | null;
}
export interface MatchResponse {
  rows: MatchedRow[];
}
export interface CandidatePage {
  candidates: Corporation[];
  nextCursor: string | null;
  hasMore: boolean;
}
export interface Settings {
  maxRows: number;
  maxFileBytes: number;
  unitPrice: number;
  acquisitionEnabled: boolean;
}
export interface Acceptance {
  requestId: number;
  lakersTaskId: string;
  idempotencyKey: string;
  status: string;
  targetCount: number;
  dispatchStatus: string;
}
export interface PendingReceipt {
  idempotencyKey: string;
  sentAt: string;
}
